import { render } from "./SidebarOrganizer.vue?vue&type=template&id=393aead6&scoped=true"
import script from "./SidebarOrganizer.vue?vue&type=script&lang=js"
export * from "./SidebarOrganizer.vue?vue&type=script&lang=js"

import "./SidebarOrganizer.vue?vue&type=style&index=0&id=393aead6&lang=scss&scoped=true"
import "./SidebarOrganizer.vue?vue&type=style&index=1&id=393aead6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393aead6"]])

export default __exports__